var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'background-color': _vm.bgcolors}),attrs:{"id":"overlay-circular"}},[_c('div',{staticClass:"loader-circular"})])}
var staticRenderFns = []

export { render, staticRenderFns }